(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-tabs-links"] && !Shopify.designMode) return;
  try {
    const container = document.querySelector(".product-tabs-links");
const placeholder = document.getElementById('product-tabs-links--item-template');
const sections = document.querySelector('simple-tabs').sections;
const productTabs = document.querySelector('.product-tabs simple-tabs')
const clickHandler = (event) => {
  // Activate the clicked tab and scroll to it:
  productTabs.activeSection = event.target.attributes.target;
  productTabs.scrollIntoView({alignToTop: true});
}
// Read sections and create links for each one (max 3)
Array.from(sections).slice(0, 3).forEach((element) => {
  title = element.textContent.trimStart();
  link = placeholder.content.cloneNode(true);
  link.querySelector('.product-tabs-links__item').textContent = title;
  link.children[0].attributes.target = element.id;
  link.children[0].addEventListener("click", clickHandler);
  container.querySelector('ul').appendChild(link);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-tabs"] && !Shopify.designMode) return;
  try {
    var tabs = document.querySelector('simple-tabs').sections;
            var tabStyle = getComputedStyle(tabs[0]);
            var displayAsTab = tabStyle.getPropertyValue('grid-row-start') == 1;
            var activeTab = tabs[0];
            // Check if items are displayed as tabs
            // Activate the first tab or the one marked as default:
            if (displayAsTab) {
                for (let i = 0; i < tabs.length; i++) {
                    let tab = tabs[i];
                    if (tab.hasAttribute('[data-default]')) {
                        activeTab = tab;
                        break;
                    }
                }
                activeTab.click();
            }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-medium-review"] && !Shopify.designMode) return;
  try {
    function jumpToReviewsTab() {
    const productTabs = document.querySelector('.product-tabs simple-tabs')
    // Activate the clicked tab and scroll to it:
    productTabs.activeSection = 'reviews';
    productTabs.scrollIntoView({alignToTop: true});
}
  } catch(e) { console.error(e); }
})();

})();
